import {
    CUSTOM_PRICE_LIST_ACTION, CUSTOM_PRICE_LIST_SUCCESS, CUSTOM_PRICE_LIST_FAIL,
    CUSTOM_PRICE_DETAIL_ACTION, CUSTOM_PRICE_DETAIL_SUCCESS, CUSTOM_PRICE_DETAIL_FAIL, CUSTOM_PRICE_DETAIL_UPDATE_ACTION, CUSTOM_PRICE_DETAIL_CREATE_ACTION
} from '../constants/Types';
import CustomPrice from './../models/CustomPrice';
import {PAGINATION} from '../constants/Define';

const initialState = {
    isFetching: false,
    isFetched: false,
    prices: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    detail: {
        price: new CustomPrice(),
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case CUSTOM_PRICE_LIST_ACTION:
            return { ...state, isFetching: true };
        case CUSTOM_PRICE_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                prices: action.prices,
                pageSize: action.pageSize,
                pageIndex: action.pageIndex,
                totalCount: action.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize))
            };
        case CUSTOM_PRICE_LIST_FAIL:
            return { ...state, isFetching: false, isFetched: true, prices: [] };
        case CUSTOM_PRICE_DETAIL_ACTION:
            return { ...state, isFetching: true, detail: initialState.detail };
        case CUSTOM_PRICE_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                detail: { price: action.price, }
            };
        case CUSTOM_PRICE_DETAIL_UPDATE_ACTION:
                return { ...state, isFetching: true };
        case CUSTOM_PRICE_DETAIL_CREATE_ACTION:
                    return { ...state, isFetching: true };
        case CUSTOM_PRICE_DETAIL_FAIL:
            return { ...state, isFetching: false, isFetched: true };
        default:
            return state;
    }
}
